import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import Flex from '@ms/yammer-web-core-ui/dist/components/Flex';
import FocusTwins from '@ms/yammer-web-core-ui/dist/util/accessibility/FocusTwins';
import type { FC } from 'react';
import React from 'react';

import { toggleLeftNavCollapsed, useIsLeftNavCollapsed } from '../store';

import CollapseIconButton from './CollapseIconButton';
import { collapsedRailSlotSize } from './collapsedRail';

const NavCollapseToggle: FC = () => {
  'use memo';

  const t = useTranslations(NavigationStrings);
  const isCollapsed = useIsLeftNavCollapsed();

  const ariaLabel = isCollapsed ? t.appNavigationExpandButtonAriaLabel() : t.appNavigationCollapseButtonAriaLabel();

  const toggle = (
    <CollapseIconButton
      ariaLabel={ariaLabel}
      ariaExpanded={!isCollapsed}
      appearance={isCollapsed ? 'transparent' : 'subtle'}
      onClick={toggleLeftNavCollapsed}
    />
  );

  if (isCollapsed) {
    return (
      <FocusTwins.Parent>
        <Flex
          shrink={0}
          justifyContent="center"
          alignItems="center"
          minHeight={collapsedRailSlotSize}
          minWidth={collapsedRailSlotSize}
        >
          <FocusTwins.Child key="expand">{toggle}</FocusTwins.Child>
        </Flex>
      </FocusTwins.Parent>
    );
  }

  return (
    <FocusTwins.Parent>
      <FocusTwins.Child key="collapse">{toggle}</FocusTwins.Child>
    </FocusTwins.Parent>
  );
};

export default NavCollapseToggle;
